import { getOrCreateAnonymousUserId } from '~/utils/nectarTracking';
import { NECTAR_SITE_ID_FIELD } from '~/utils/nectarTrackingFields';

/**
 * Appends the client-only Nectar attribution params to an upgrade form submission.
 *
 * `nectar_page_block` and `visit_token` already ride along as form-serialized hidden
 * inputs, but these two are computed client-side (no SSR value) so they must be appended
 * at submit time. Call this from every upgrade submit path (card, payment element, Apple
 * Pay) so attribution stays consistent across them.
 */
export const appendNectarUpgradeParams = (formData: FormData, siteId?: string): void => {
  formData.append('nectar_upgrade_url', window.location.href);
  formData.append('nectar_anonymous_user_id', getOrCreateAnonymousUserId());
  if (siteId) {
    formData.append(NECTAR_SITE_ID_FIELD, siteId);
  }
};
